module.exports = __webpack_public_path__ + "CreativeDirection20.png?c453d79c34b8db36a048b7f665808b61";


//////////////////
// WEBPACK FOOTER
// ./src/assets/CreativeDirection20.png
// module id = 32
// module chunks = 0